import { useMemo } from 'react'

import { useLineChart } from './use-line-chart'

interface Props {
  dataKey: string
  fontSize?: number
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tickFormatter: (value: any, index: number, length: number) => string[]
}
export const LineChartXAxis: React.FC<Props> = ({ dataKey, fontSize = 11.25, tickFormatter }) => {
  const { data, plotAreaHeight, plotAreaPadding, xScale } = useLineChart()

  const xs = useMemo(() => {
    return data.map((_, i) => xScale(i))
  }, [data, xScale])

  const length = xs.length
  const areAllTicksShown = length <= 13

  return (
    <g transform={`translate(0, ${plotAreaHeight + (plotAreaPadding?.top ?? 0) + 22})`}>
      {xs.map((x, i) => {
        if (!areAllTicksShown && i % 2 !== 0) {
          return null
        }

        const [label1, label2] = tickFormatter(data[i]?.[dataKey], i, length)

        const isFirst = i === 0
        const isLast = i === length - 1
        const isMiddle = i === Math.floor(length / 2)

        return (
          <text key={i} className="select-none" x={x} fontSize={fontSize} fill="#999" textAnchor="middle">
            <tspan x={x}>{label1}</tspan>
            {!!label2 && (isFirst || isLast || isMiddle) && (
              <tspan x={x} dy={13.75}>
                {label2}
              </tspan>
            )}
          </text>
        )
      })}
    </g>
  )
}
